"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DarkCheckbox = _interopRequireDefault(require("../../DarkCheckbox"));

var _styles = require("./styles");

var _ = require("../..");

var Item =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Item, _React$Component);

  function Item() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Item);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Item)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "clickHandler", function (event, itemId, selected, children, genre) {
      var isChecked;
      var label;

      if (_this.props.type === 'desktop') {
        isChecked = !selected;
        label = children;
      } else {
        isChecked = event.target.checked;
        label = event.target.labels[0].textContent;
      }

      _this.props.onChangeHandler({
        itemId: itemId,
        label: label,
        genre: genre
      }, !isChecked);
    });
    return _this;
  }

  (0, _createClass2.default)(Item, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          itemId = _this$props.itemId,
          className = _this$props.className,
          children = _this$props.children,
          disabled = _this$props.disabled,
          type = _this$props.type,
          selected = _this$props.selected,
          genre = _this$props.genre;
      var rootStyle = type === 'desktop' ? _styles.rootStyleDesktop : _styles.rootStyleMobile;

      if (type === 'desktop') {
        return _react.default.createElement("div", {
          key: itemId,
          className: (0, _classnames.default)(rootStyle, className)
        }, _react.default.createElement(_.DarkButton, {
          className: (0, _classnames.default)(_styles.itemButtons, {
            selected: selected
          }),
          disabled: disabled,
          onClick: function onClick(event) {
            return _this2.clickHandler(event, itemId, selected, children, genre);
          },
          size: "small"
        }, children));
      }

      return _react.default.createElement("div", {
        key: itemId,
        className: (0, _classnames.default)(rootStyle, className)
      }, _react.default.createElement(_DarkCheckbox.default, {
        defaultChecked: selected,
        disabled: disabled,
        onChange: function onChange(event) {
          return _this2.clickHandler(event, itemId, null, null, genre);
        },
        label: children
      }));
    }
  }]);
  return Item;
}(_react.default.Component);

Item.propTypes = {
  itemId: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  selected: _propTypes.default.bool
};
Item.defaultProps = {
  itemId: '',
  className: '',
  disabled: false,
  selected: false
};
var _default = Item;
exports.default = _default;